<template>
  <div>
    <h1 class="display-1 primary--text">
      {{ $t('message.standard_values_title') }}
    </h1>

    <v-data-table
      :headers="headers"
      :items="standardValues.data"
      class="elevation-1"
      :pagination.sync="pagination"
      item-key="_id"
    >
      <template v-slot:headerCell="item">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="item.header.text" />
      </template>
      <template v-slot:items="row">
        <td>{{ row.item.date | formatDate }}</td>
        <td>{{ row.item.priceCalf | euro }}</td>
        <td>{{ row.item.yieldOfCulledCow | euro }}</td>
        <td>{{ row.item.vemNeedPerDayDryPeriod }}</td>
        <td>{{ row.item.dveNeedPerDayDryPeriod }}</td>
        <td>{{ row.item.standardPer24MonthsRearing | euro }}</td>
        <td>{{ row.item.otherBreedingCosts | euro }}</td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          fixed
          bottom
          right
          dark
          class="mb-4"
          v-on="on"
        >
          <v-icon dark>
            add
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('message.add_standard_value') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="standardValue.date"
                      :label="$t('message.std_val_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="standardValue.date"
                    @input="dateMenu = false"
                  />
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="standardValue.priceCalf"
                  :label="$t('message.std_val_priceCalf').replace('<br>', ' ')"
                  prepend-inner-icon="fa-euro-sign"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="standardValue.yieldOfCulledCow"
                  :label="
                    $t('message.std_val_yieldOfCulledCow').replace('<br>', ' ')
                  "
                  prepend-inner-icon="fa-euro-sign"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="standardValue.vemNeedPerDayDryPeriod"
                  :label="
                    $t('message.std_val_vemNeedPerDayDryPeriod').replace(
                      '<br>',
                      ' '
                    )
                  "
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="standardValue.dveNeedPerDayDryPeriod"
                  :label="
                    $t('message.std_val_dveNeedPerDayDryPeriod').replace(
                      '<br>',
                      ' '
                    )
                  "
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="standardValue.standardPer24MonthsRearing"
                  :label="
                    $t('message.std_val_standardPer24MonthsRearing').replace(
                      '<br>',
                      ' '
                    )
                  "
                  prepend-inner-icon="fa-euro-sign"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="standardValue.otherBreedingCosts"
                  :label="
                    $t('message.std_val_otherBreedingCosts').replace(
                      '<br>',
                      ' '
                    )
                  "
                  prepend-inner-icon="fa-euro-sign"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="darken-1"
            flat
            @click="closeDialog"
          >
            {{ $t('message.close') }}
          </v-btn>
          <v-btn
            color="secondary"
            @click="save"
          >
            {{ $t('message.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Targets',
  data: (vm) => ({
    headers: [
      { text: vm.$t('message.std_val_date'), value: 'date' },
      {
        text: vm.$t('message.std_val_priceCalf'),
        value: 'priceCalf',
        sortable: false,
      },
      {
        text: vm.$t('message.std_val_yieldOfCulledCow'),
        value: 'yieldOfCulledCow',
        sortable: false,
      },
      {
        text: vm.$t('message.std_val_vemNeedPerDayDryPeriod'),
        value: 'vemNeedPerDayDryPeriod',
        sortable: false,
      },
      {
        text: vm.$t('message.std_val_dveNeedPerDayDryPeriod'),
        value: 'dveNeedPerDayDryPeriod',
        sortable: false,
      },
      {
        text: vm.$t('message.std_val_standardPer24MonthsRearing'),
        value: 'standardPer24MonthsRearing',
        sortable: false,
      },
      {
        text: vm.$t('message.std_val_otherBreedingCosts'),
        value: 'otherBreedingCosts',
        sortable: false,
      },
    ],
    dialog: false,
    editedIndex: -1,
    standardValue: {
      date: new Date().toISOString().substr(0, 10),
    },
    dateMenu: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: -1, // -1 for All",
      sortBy: 'date',
    },
  }),
  computed: {
    ...mapState(['standardValues']),
  },
  created() {
    this.$store.dispatch('getStandardValues')
  },
  methods: {
    save: function () {
      ;[
        'priceCalf',
        'yieldOfCulledCow',
        'standardPer24MonthsRearing',
        'otherBreedingCosts',
      ].forEach((key) => {
        this.standardValue[key] = this.standardValue[key] * 100
      })
      this.$store.dispatch('saveStandardValues', this.standardValue)
      this.closeDialog()
    },
    closeDialog: function () {
      this.dialog = false
      this.standardValue = {
        date: new Date().toISOString().substr(0, 10),
      }
    },
  },
}
</script>
<style></style>
